(function () {
    'use strict';

    angular
        .module('wsl.core', [
            /* Angular modules */
            'ngAnimate',
            'ngSanitize',
            'ngMessages',
            /* Cross-app modules */
            'wsl.exception'
            /* 3rd-party modules */
        ])
        .run(runCore);

    runCore.$inject = ['moment'];

    /* @ngInject */
    function runCore (moment) {
        moment.locale('ru');
    }
})();
